// Languages relevant to North America + Canada.
// Order: most-common first. `code` = ISO 639-1 used by translation APIs.
export const LANGUAGES = [
  { code: 'en',    label: 'EN', name: 'English',                native: 'English' },
  { code: 'fr',    label: 'FR', name: 'French',                 native: 'Français' },
  { code: 'es',    label: 'ES', name: 'Spanish',                native: 'Español' },
  { code: 'zh-CN', label: '中文', name: 'Chinese (Simplified)',  native: '简体中文' },
  { code: 'zh-TW', label: '繁體', name: 'Chinese (Traditional)', native: '繁體中文' },
  { code: 'ar',    label: 'AR', name: 'Arabic',                 native: 'العربية' },
  { code: 'tl',    label: 'TL', name: 'Filipino (Tagalog)',     native: 'Filipino' },
  { code: 'pt',    label: 'PT', name: 'Portuguese',             native: 'Português' },
  { code: 'vi',    label: 'VI', name: 'Vietnamese',             native: 'Tiếng Việt' },
  { code: 'ko',    label: 'KO', name: 'Korean',                 native: '한국어' },
  { code: 'it',    label: 'IT', name: 'Italian',                native: 'Italiano' },
  { code: 'de',    label: 'DE', name: 'German',                 native: 'Deutsch' },
  { code: 'ru',    label: 'RU', name: 'Russian',                native: 'Русский' },
]

export const DEFAULT_LANG = 'en'

export function findLanguage(code) {
  return LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]
}
